import { useContext } from 'react';

import { TimeseriesDataContext } from '../context/TimeseriesData.context.js';

export const useTimeseriesData = () => useContext(TimeseriesDataContext);
